module.exports = __webpack_public_path__ + "static/media/upload-cloud-02.57288c6b.svg";